import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'semantic-ui-react'
import { Field } from 'redux-form/immutable'
import { SemanticInputMask } from '../FormComponents'
import { maskCurrency } from '../../utils/masks'
import { required } from '../../utils/validations'

const RenderFormValoresNA = ({ mes, fields }) => {
  return fields.map((valor_na, index) => (
    <Table.Cell key={index}>
      <Field fluid
        name={`${valor_na}.valor_na`}
        placeholder={maskCurrency.placeholder}
        mask={maskCurrency.mask()}
        validate={[required]}
        component={SemanticInputMask}
        label='kWh'
        tabIndex={24 + mes}
      />
    </Table.Cell>
  ))
}

RenderFormValoresNA.propTypes = {
  mes: PropTypes.number,
  fields: PropTypes.object,
  loading: PropTypes.bool,
}

export default RenderFormValoresNA
